import { Endpoint } from '@/types/api.type.ts';

export const feedbackEndpoints: Endpoint[] = [
    {
        name: 'SendFeedback',
        method: 'post',
        path: '/support/feedback',
    },
];
